import { render, staticRenderFns } from "./announcementsPage.vue?vue&type=template&id=038ef8a6&scoped=true"
import script from "./announcementsPage.vue?vue&type=script&lang=js"
export * from "./announcementsPage.vue?vue&type=script&lang=js"
import style0 from "./announcementsPage.vue?vue&type=style&index=0&id=038ef8a6&prod&scoped=true&lang=css"
import style1 from "./announcementsPage.vue?vue&type=style&index=1&id=038ef8a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ef8a6",
  null
  
)

export default component.exports